import ToastComponent from "./ToastComponent"

import { useAppSelector } from "reducers/store"
import Heading from "components/Typography/Heading"

const GlobalToast = () => {
  const { success, error, message } = useAppSelector((state) => state.toast)

  return (
    <>
      {(error || success) && (
        <ToastComponent variant={error ? "error" : "success"}>
          <Heading variant="h6" color={error ? "error" : "success"} data-testid="global-toast-message">
            {message}
          </Heading>
        </ToastComponent>
      )}
    </>
  )
}

export default GlobalToast
